import mockRacks from '../data/racks.json';
import adaptersData from '../data/adapters.json';

// Функция для поиска багажника по ID с восстановлением информации об адаптере
export const findRackById = (id, adapterInfo = null, needsAdapter = false, adapterPrice = 0, carId = null) => {
  const rack = mockRacks.find(rack => rack.id === id);

  if (rack && needsAdapter) {
    return {
      ...rack,
      needsAdapter: true,
      adapterInfo: adapterInfo,
      adapterPrice: adapterPrice,
      carId: carId
    };
  }

  return rack;
};